import { Link } from "react-router-dom";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import FooterDetails from "../layout/FooterDetails";
import BreakPoints from "../BreakPoints";
import SideBar from "../layout/SideBar";
import { useAuth } from "../context/AuthContext";
import { useQueries } from "@tanstack/react-query";
import { QUESTIONS } from "../api/Api";
import QuestionsMap from "../components/QuestionManagement/QuestionsMap";
import LoadingPage from "./LoadingPage";
import { Axios } from "../Axios/createAxios";

export default function Home() {
  const { xSmall, small, medium, large } = BreakPoints();
  const { isAuth } = useAuth();

  const fetchTops = async () => {
    try {
      const topUsersResponse = await Axios.get(`/users`);
      console.log(topUsersResponse);
      return topUsersResponse.data.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  const fetchData = async ({ pageParam = null }) => {
    try {
      const res = await Axios.get(`/${QUESTIONS}`, {
        params: {
          cursor: pageParam,
          initial: !pageParam,
          order: "answers_count",
          period: "year",
        },
      });

      return res.data.details;
    } catch (er) {
      throw er;
    }
  };

  const results = useQueries({
    queries: [
      { queryFn: fetchData, queryKey: ["top8Questions"], staleTime: Infinity },
      { queryFn: fetchTops, queryKey: ["top10Users"], staleTime: Infinity },
    ],
  });
  console.log(results);
  const top8Questions = results[0];
  const topUsers = results[1];
  console.log(top8Questions);

  const TopUsersC = () => {
    return (
      <div className="tops">
        <h2>Top 10 users</h2>
        <ol className="pb-5" style={{ borderBottom: "solid 1px" }}>
          {topUsers?.data?.map((item, index) => {
            const name = item.name;
            const points = item.points;
            return (
              <li key={index} className="p-5 radius-3 " style={{ flexBasis: "150px" }}>
                <span className="block">{name}</span>
                <span className="succ-c">{points}px</span>
              </li>
            );
          })}
        </ol>
      </div>
    );
  };
  return (
    <>
      {(top8Questions.isLoading || topUsers.isLoading) && <LoadingPage />}
      <div className={`home-page `}>
        {medium || large ? <SideBar /> : <Header />}
        <div className="home-content pl-10 pr-10">
          <div className={`${!small && !xSmall ? "w-50 auto-m" : "pl-10 pr-10"}`}>
            <h1>{!isAuth ? "Join us" : <>Welcome Back!</>}</h1>
            <p className="d-grid">
              {!isAuth ? (
                <>
                  Your votes matter. Your answers could help someone. Your questions—big or small—the community will
                  decide their worth. And you’ll be part of that community.
                  <Link to={"about"}>Learn More..</Link>
                </>
              ) : (
                <>
                  Your contributions make a difference. Check out new questions and share your knowledge!
                  <Link to="/query" className="mixed-c">
                    Explore Questions
                  </Link>
                </>
              )}
            </p>
          </div>

          {TopUsersC()}
          <section>
            <p>Most Popular Questions of the year </p>
            <div className="home-questions">
              <QuestionsMap questions={top8Questions?.data?.data || []} />
            </div>
          </section>
          <div className="p-5">
            <div>
              <h5>help us</h5>
              <p>
                If you have any ideas or feedback, please
                <Link to={"about#feedback"} className="mixed-c m-5">
                  share them with us
                </Link>
                . It will help, and thank you.
              </p>
            </div>

            <div>
              <h5></h5>
            </div>
          </div>
        </div>
        <FooterDetails />
        {(small || xSmall) && <Footer />}
      </div>
    </>
  );
}
